module.exports = __webpack_public_path__ + "static/media/lepes1.8672675d.png";